import { DashboardProfile } from '@/pages/DashboardProfile'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/$orgId/dashboard/profile')({
  component: DashboardProfile,
  meta: () => [{ title: 'Profile' }],
})
